'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');


const DEFAULTS={
triggerEvent:'click',
directive:'pulsar-text-tooltip',
anchorToTargetSide:'top',
alignFromTooltipSide:'bottom'};let





TooltipDirective=function(){function TooltipDirective(){_classCallCheck(this,TooltipDirective)}TooltipDirective.prototype.




factory=function factory(tooltipService){
return{
restrict:'A',
scope:{
textContent:'@pulsarTooltipText',
directive:'@pulsarTooltipDirective',
anchorToTargetSide:'@pulsarTooltipAnchor',
alignFromTooltipSide:'@pulsarTooltipAlignFrom',
bindings:'=pulsarTooltipData'},

link:{
pre:function(scope,element,attrs){
_.defaults(scope,DEFAULTS);
const triggerEvent=attrs.pulsarTooltipTrigger||DEFAULTS.triggerEvent;

element.on(triggerEvent,function(event){
event.preventDefault();
event.stopPropagation();

if(tooltipService.currentTarget===event.target)return;
tooltipService.closeTooltip();

const childScope=scope.$new(!1,scope);
tooltipService.openTooltip(childScope,event.target);
});
}}};


};_createClass(TooltipDirective,null,[{key:'type',get:function(){return'directive'}}]);return TooltipDirective}();


module.exports=TooltipDirective;
module.exports.prototype.factory.$inject=['tooltipService'];
//# sourceMappingURL=tooltipDirective.js.map
